<template>
  <Modal v-model:is-open="isOpen" class="logout-modal">
    <Button
      class="flex self-end"
      prefix_icon="ic-x"
      :c_style="{ type: 'tertiary', style: 'B' }"
      @click="handleClose"
    />

    <DynamicAsset
      class="self-center"
      type="json"
      title="Are you sure you want to logout?"
      :animationData="logoutAnimation"
    />

    <div class="flex flex-col items-center gap-4 font-secondary font-medium">
      <h1 class="text-size_6 font-bold">Are you sure you want to logout?</h1>

      <p class="text-center text-neutral-800 opacity-60">
        To log back in, you'll need to enter your details in the login form.
      </p>
    </div>

    <div class="flex flex-col gap-4 md:flex-row md:gap-6">
      <Button
        class="w-full"
        :label="$t('user.account.actions.keep_account_open')"
        @click="$emit('keep')"
      />
      <Button
        class="w-full"
        :c_style="{ type: 'secondary' }"
        :label="$t('user.account.actions.logout')"
        @click="$emit('logout')"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import Modal from "~/components/common/Atom/Modal.vue";
import DynamicAsset from "~/components/common/Atom/DynamicAsset.vue";
import logoutAnimation from "~/assets/animations/logout.json";

const isOpen = defineModel("isOpen", { default: false });

const emits = defineEmits(["close", "keep", "logout"]);

const handleClose = () => {
  isOpen.value = false;
  emits("close");
};
</script>

<style>
.logout-modal {
  .modal-content {
    @apply flex flex-col gap-10 pb-14 pt-7;
  }
}
</style>
